import {PostProductBody} from '../../pages/Bag/Bag';
import AxiosService from '../AxiosService';

const VersionGet = async () => {
  const instance = AxiosService.createAuthAxiosInstance();
  const response = await instance.get(
    '/v1/mobile/getMinVersion',
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
  return response.data;
};

export default {
  VersionGet 
};
